import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import config from '@/config';

Vue.use(Vuex);

export const RESET_LOADING = 'RESET_LOADING';
export const BEGIN_LOADING = 'BEGIN_LOADING';
export const END_LOADING = 'END_LOADING';
export const SET_ANSWER = 'SET_ANSWER';
export const SET_ATTACHMENT = 'SET_ATTACHMENT';
export const SET_SCORE = 'SET_SCORE';
export const SET_PERSONAL_FIELD = 'SET_PERSONAL_FIELD';
export const SET_LEGAL_FIELD = 'SET_LEGAL_FIELD';
export const SET_LOGIN_FIELD = 'SET_LOGIN_FIELD';

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: config.appId,
  })],

  state: {
    loadingItems: 0,
    answer: undefined,
    attachment: undefined,
    score: undefined,
    personal: {},
    legal: {},
    login: {},
  },

  getters: {
    isLoading: state => state.loadingItems > 0,
  },

  mutations: {
    [RESET_LOADING](state) {
      state.loadingItems = 0;
    },

    [BEGIN_LOADING](state) {
      state.loadingItems += 1;
    },

    [END_LOADING](state) {
      state.loadingItems -= 1;
    },

    [SET_ANSWER](state, { answer }) {
      state.answer = answer;
    },

    [SET_ATTACHMENT](state, { attachment }) {
      state.attachment = attachment;
    },

    [SET_SCORE](state, { score }) {
      state.score = score;
    },

    [SET_PERSONAL_FIELD](state, { key, value }) {
      Vue.set(state.personal, key, value);
    },

    [SET_LEGAL_FIELD](state, { key, value }) {
      Vue.set(state.legal, key, value);
    },

    [SET_LOGIN_FIELD](state, { key, value }) {
      Vue.set(state.login, key, value);
    },
  },

  actions: {},
});
